<script>
export default {
    name: "PatientQueue",

    data() {
        return {
            search: ``,
            patients: [],
            viewRoundInvestigations: false,
            roundFilter: {
                search: ``,
            },
            pendingInvestigations: [],
        };
    },

    components: {

        "view-pending-investigations": () => import('./modals/PendingInpatientInvestigations.vue'),
    },

    mounted() {
        this.$root.loading = true;
        Promise.allSettled([ this.fetchQueue(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchQueue() {
            let url = `Radiology/GetRadiologyQueue`;
                url += this.search ? `?SearchText=${this.search}` : ``;

            return this.$http.get(url).then(response => {
                        this.patients = response.data;
                    }).catch(() => {});
        },

        fetchWardRoundReport() {
            this.$root.loading=true;
            let url = `Inpatient/GetWardRoundPendingRadiology`;
                url += this.roundFilter.search ? `?SearchText=${this.roundFilter.search}` : ``;

            return this.$http.get(url).then(response => {
                this.pendingInvestigations=response.data;
                this.$root.loading=false;
                this.viewRoundInvestigations=true;
            }).catch(() => { this.$root.loading=false; });
        },

        printQueue() {
            window.open(`/radiology/patients-print`, 
                '_blank', 
                `RadiologyPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                  <div class="w-full flex flex-wrap">
                      <div class="flex-1">
                          <h5 class="font-medium text-sm">Radiology Queue</h5>
                      </div>
                      <div class="flex-1 text-right">
                          <button 
                            @click.prevent="fetchWardRoundReport"
                            class="btn-sm btn-primary text-xs rounded">
                                <i class="fa fa-list"></i> Pending Inpatient Investigations</button>
                      </div>
                      <view-pending-investigations 
                        :showModal="viewRoundInvestigations"
                        :pendingInvestigations="pendingInvestigations"
                        @closeModal="viewRoundInvestigations=false"
                      />
                  </div>
              </template>
              <template v-slot:card-body>
                  <div class="w-full overflow-auto max-h-screen">
                        <div class="w-full flex flex-wrap">
                            <div class="md:w-1/4 sm:w-1/2 p-tiny">
                                <input type="text" @keydown.enter="fetchQueue" v-model.trim="search" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/12 sm:w-1/4 p-tiny">
                                <button 
                                    class="btn-sm btn-primary text-xs rounded" 
                                        @click.prevent="fetchQueue"><i class="fa fa-search"></i> Filter</button>
                            </div>
                            <div class="md:w-1/12 sm:w-1/4 p-tiny">
                                <button 
                                    class="btn-sm btn-info text-xs rounded" 
                                    @click.prevent="printQueue"><i class="fa fa-print"></i> Print</button>
                            </div>
                        </div>
                        <table class="table">
                            <thead class="bg-blue-500 text-white text-sm">
                                <tr class="flex w-full">
                                    <th class="p-tiny w-1/6">Patient</th>
                                    <th class="p-tiny flex-1">Date</th>
                                    <th class="p-tiny flex-1">File</th>
                                    <th class="p-tiny w-1/6">Payment</th>
                                    <th class="p-tiny flex-1">Status</th>
                                    <th class="p-tiny flex-1">Payment Status</th>
                                    <th class="p-tiny flex-1">Comment</th>
                                    <th class="p-tiny flex-1">Select</th>
                                </tr>
                            </thead>
                            <tbody class="bg-gray-200 text-xs font-medium flex flex-col items-center overflow-auto w-full" style="height: 65vh;">
                                <tr class="flex w-full" 
                                    v-for="(pat, idx) in patients" :class="pat.isUrgent ? `bg-red-300` : `` " :key="idx">
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN: {{ pat.patienT_ID }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">IP: {{ pat.ipfileno || `-` }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">OP: {{ pat.opfileno || `-` }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: {{ pat.dob | dateFormat }}</h5>
                                    </td>
                                    <td class="p-tiny flex-1">{{ pat.date | dateFormat }}  <h5 class="text-xs leading-5 font-medium text-gray-700">Queue Time: {{ pat.timeOnQueue }}</h5></td>
                                    <td class="p-tiny flex-1">
                                        <router-link
                                          :to="{
                                            name: pat.patienT_ID ? `med-f.visit.index` : ``,
                                            params: {
                                              patientID: pat.patienT_ID,
                                              visitNo: pat.visitNo,
                                            },
                                            query: {
                                              from: $route.path
                                            }
                                          }"
                                          class="btn-sm btn-info text-xs rounded"
                                        >
                                          <i class="fa fa-file-medical-alt"></i> Open Medical File
                                        </router-link>
                                    </td>
                                    <td class="p-tiny w-1/6 break-words">{{ pat.pmode }}</td>
                                    <td class="p-tiny flex-1">
                                        <h5 class="font-medium">{{ pat.patientstatus }}</h5>
                                        <h5 class="font-medium">Ward: {{ pat.ward || `-` }}</h5>
                                        <h5 class="font-medium">Bed: {{ pat.bed || `-` }}</h5>
                                    </td>
                                    <td class="p-tiny flex-1">
                                        {{ pat.payment }}
                                    </td>
                                    <td class="p-tiny flex-1">
                                        {{ pat.memo || `-` }}
                                    </td>
                                    <td class="p-tiny flex-1">
                                        <router-link 
                                            class="btn-sm btn-primary text-xs rounded"
                                            :to="{ 
                                                name: `radiology.record-results.create`, 
                                                params: { 
                                                    patientID: pat.patienT_ID, 
                                                    visitNO: pat.visitNo 
                                                } 
                                            }"><i class="fa fa-pen"></i> Results</router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
